import React from 'react';
import { HelpWrapper } from './HelpWrapper';
import { HelpImage } from './Journaling';

export function Basics() {
  return (
    <HelpWrapper>
      <h1>How to use exegesis</h1>
      <h2>Getting started</h2>
      <HelpImage src="/help_images/newnote.gif" />
      <p>
        Click the 'new note' button in the upper left hand corner to create a
        note. Select a note in the sidebar to open that note.
      </p>
      <h3>Tags</h3>
      <HelpImage src="/help_images/tagtag.gif" />
      <p>
        You can organize content in exegesis by leaving a tag. This is done by
        pressing '#', then typing a tag, then pressing 'enter' or clicking the
        tag you want from the autocomplete menu.
      </p>

      <h2>Finding content</h2>
      <p>There are multiple ways to find tagged content.</p>
      <HelpImage src="/help_images/basictagbrowser.gif" />
      <p>
        One way is to simply click a tag. This will bring you to a page showing
        you all the text that share that tag.
      </p>
      <p>You can add additional tag filters to narrow your search.</p>
      <HelpImage src="/help_images/basictagbrowser2.gif" />
      <p>
        Another option is to click the 'tags' tab in the upper left corner. This
        will bring you to the tag page. Here, you can select multiple tags and
        it will show you all text that has been marked with those tags.
      </p>

      <h2>Linking content</h2>
      <p>
        If you assign a title to a page, you can link to it by creating a tag
        with the title of that page. Clicking that tag will direct you to the
        page. The page will also show all the places its been linked to at the
        bottom.
      </p>
      {/* <p>Alternatively, you can create a page for an existing tag.</p>
      <p>
        Changing the title of a page will change all tags that link to it. This
        one way to rename tags
      </p> */}
      <h2>Publishing content</h2>
      <p>
        Press 'publish note' button to publish your note. Once it has been
        published, you can access the published note with the link titled 'note
        is published here' beneath the title of the note.
      </p>
      <p>
        If you make further changes to the note and want to update the published
        version with these changes, click 'publish changes.'
      </p>
      <p>If you want to unpublish the note, click 'unpublish note.'</p>
    </HelpWrapper>
  );
}
